<template>
<div class="chapter">
<div class="inner_page">
<div id="d57691ac4acf6-d1e363"><span id="pageiii">
<h1 class="book-title">DAUGHTER OF ASHES</h1>
<h2 class="book-subtitle">A Hannah Ives Mystery</h2>
<h2 class="book-author">Marcia Talley</h2>
<p class="publisher-logo"><span class="image-centered" id="imgd1e957"><img alt="" src="OEBPS/images/9781780106519_epub_002.jpg"/></span></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106519_epub_tp.vue?10b9fb9a